export default {
  inject: ['load'],
  data() {
    return {
      allGeographicalTypes: [],
    };
  },
  methods: {
    getAllGeographicalTypes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllGeographicalTypes').then(() => {
        if (this.$store.state.geographicalTypeModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allGeographicalTypes = this.$store.state.geographicalTypeModule.allGeographicalTypes;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.geographicalTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.geographicalTypeModule.successFlag) {
                this.getAllGeographicalTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.geographicalTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllGeographicalTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      const errorMessage = this.$store.state.geographicalTypeModule.error;
      this.showErrorAlert(errorMessage);
    },
  },
};
